"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatAudioHelper = void 0;
class ChatAudioHelper {
    static setVolume(volume) {
        ChatAudioHelper.volume = Math.max(0, Math.min(100, Number(volume) || 0));
        if (ChatAudioHelper.currentAudio) {
            ChatAudioHelper.currentAudio.volume = ChatAudioHelper.volume / 100;
        }
    }
    static stopCurrentAudio() {
        if (ChatAudioHelper.currentAudio) {
            console.log('[ChatAudioHelper] stopCurrentAudio');
            ChatAudioHelper.currentAudio.pause();
            ChatAudioHelper.currentAudio.currentTime = 0;
            ChatAudioHelper.currentAudio = null;
        }
    }
    static pauseCurrentAudio() {
        var _a;
        (_a = ChatAudioHelper.currentAudio) === null || _a === void 0 ? void 0 : _a.pause();
    }
    static resumeCurrentAudio() {
        var _a;
        (_a = ChatAudioHelper.currentAudio) === null || _a === void 0 ? void 0 : _a.play().catch(error => {
            console.error('[ChatAudioHelper] resume failed', error);
        });
    }
    static playBase64Audio(base64Data, onEnd, onStart) {
        try {
            console.log('[ChatAudioHelper] playBase64Audio, base64 length:', base64Data === null || base64Data === void 0 ? void 0 : base64Data.length);
            ChatAudioHelper.stopCurrentAudio();
            // Create a data URL from the base64 string
            const audioDataUrl = `data:audio/mp3;base64,${base64Data}`;
            const audio = new Audio(audioDataUrl);
            audio.volume = ChatAudioHelper.volume / 100;
            ChatAudioHelper.currentAudio = audio;
            // Listen for when the audio starts playing
            audio.addEventListener('playing', () => {
                console.log('[ChatAudioHelper] audio playing');
                onStart === null || onStart === void 0 ? void 0 : onStart();
            });
            // Listen for when the audio finishes playing
            audio.addEventListener('ended', () => {
                console.log('[ChatAudioHelper] audio ended');
                onEnd();
            });
            // Also handle errors to ensure we reset the talk state
            audio.addEventListener('error', (e) => {
                console.error('[ChatAudioHelper] audio error', audio.error, e);
                onEnd();
            });
            audio.play().then(() => {
                console.log('[ChatAudioHelper] audio.play() resolved');
            }).catch(error => {
                console.error('[ChatAudioHelper] audio.play() rejected (autoplay policy?):', error);
                onEnd();
            });
        }
        catch (error) {
            console.error('[ChatAudioHelper] playBase64Audio failed', error);
        }
    }
    static downloadBase64Audio(base64Data, originalText) {
        try {
            // Create a data URL from the base64 string
            const audioDataUrl = `data:audio/mp3;base64,${base64Data}`;
            // Create a temporary anchor element for download
            const link = document.createElement('a');
            link.href = audioDataUrl;
            // Generate a filename based on the text (truncated and sanitized)
            const sanitizedText = originalText.replace(/[^a-zA-Z0-9\s]/g, '').substring(0, 50);
            const filename = sanitizedText ? `tts_${sanitizedText.replace(/\s+/g, '_')}.mp3` : 'tts_audio.mp3';
            link.download = filename;
            // Append to body, click, and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        catch (error) {
            // Error downloading audio from base64
        }
    }
    static async audioRecordingHandle(state) {
        const audioService = this.chatService.getAudioService();
        const isRecording = audioService.getRecordingStatus();
        this.isRecording = isRecording;
        await this.chatService.handleAudioRecording(state, (transcription) => {
            this.appendInputTextToChat(transcription);
        });
        const newRecordingState = audioService.getRecordingStatus();
        this.isRecording = newRecordingState;
    }
    static async streamTextToAudio(text) {
    }
}
exports.ChatAudioHelper = ChatAudioHelper;
ChatAudioHelper.currentAudio = null;
ChatAudioHelper.volume = 100;
